/** ---------------------------------------------------------------------------------------
 * --  LICENSE AGREEMENT -- *
 This software is licensed under the following terms:

 * -- GRANT OF LICENSE | RESTRICTIONS -- *
 Subject to the terms and conditions of this license, the copyright holders
 hereby grant you a non-exclusive, non-transferable, revocable license to use,
 copy, modify, and distribute the software.
 You are expressly prohibited from selling or commercially exploiting the software.
 Unauthorized use, reproduction, or distribution of the software, or any part
 thereof, is strictly prohibited.

 * -- AUTHORIZED USERS | INTELLECTUAL PROPERTY -- *
 This license is granted only to the individual or entity to whom the software is
 directly distributed by the copyright holders. Any use by other individuals or
 entities is unauthorized and in violation of this license. The software is
 protected by copyright and other intellectual property laws.
 The copyright holders retain all rights, title, and interest in the software.

 * -- GOVERNING LAW -- *
 This license is governed by and construed in accordance with the laws of Romania.
 Any legal action or proceeding related to this license shall be brought exclusively
 in the courts of Romania.

 [Weddify x Diaphan Stationery] © [2024] All rights reserved.
 -------------------------------------------------------------------------------------- **/

import React from 'react';
import {MdOutlineTableBar} from "react-icons/md";
import {
    PiBookOpenTextThin,
    PiChatTeardropDotsLight,
    PiEnvelopeOpenThin, PiGlobeThin,
    PiQrCodeThin
} from "react-icons/pi";
import AppStatic from "../../utils/AppStatic";

const AppHook = () => {
    return (
        <div className="relative mt-2 md:mt-4 md:mb-6">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 w-full items-center justify-center">
                <div className="text-center pb-5 md:pb-20">
                    <PiEnvelopeOpenThin className="text-6xl m-auto"/>
                    <p className="mt-2 uppercase text-2xl font-bold tracking-widest">
                        {AppStatic.appStaticHookFirst.ro.translation}
                    </p>
                    <p className="text-mono-1000 text-base">
                        {AppStatic.appStaticHookFirstText.ro.translation}
                    </p>
                </div>
                <div className="text-center pb-5 md:pb-20">
                    <MdOutlineTableBar className="text-6xl m-auto"/>
                    <p className="mt-2 uppercase text-2xl font-bold tracking-widest">
                        {AppStatic.appStaticHookPlacement.ro.translation}
                    </p>
                    <p className="text-mono-1000 text-base">
                        {AppStatic.appStaticHookPlacementText.ro.translation}
                    </p>
                </div>
                <div className="text-center pb-5 md:pb-20">
                    <PiQrCodeThin className="text-6xl m-auto"/>
                    <p className="mt-2 uppercase text-2xl font-bold tracking-widest">
                        {AppStatic.appStaticHookSecond.ro.translation}
                    </p>
                    <p className="text-mono-1000 text-base">
                        {AppStatic.appStaticHookSecondText.ro.translation}
                    </p>
                </div>
                <div className="text-center pb-5 md:pb-20">
                    <PiChatTeardropDotsLight className="text-6xl m-auto"/>
                    <p className="mt-2 uppercase text-2xl font-bold tracking-widest">
                        {AppStatic.appStaticHookThird.ro.translation}
                    </p>
                    <p className="text-mono-1000 text-base">
                        {AppStatic.appStaticHookThirdText.ro.translation}
                    </p>
                </div>
                <div className="text-center pb-5 md:pb-20">
                    <PiGlobeThin className="text-6xl m-auto"/>
                    <p className="mt-2 uppercase text-2xl font-bold tracking-widest">
                        {AppStatic.appStaticHookLanguage.ro.translation}
                    </p>
                    <p className="text-mono-1000 text-base">
                        {AppStatic.appStaticHookLanguageText.ro.translation}
                    </p>
                </div>
                <div className="text-center pb-5 md:pb-20">
                    <PiBookOpenTextThin className="text-6xl m-auto"/>
                    <p className="mt-2 uppercase text-2xl font-bold tracking-widest">
                        {AppStatic.appStaticHookJourney.ro.translation}
                    </p>
                    {/*<p className="text-mono-1000 text-base">*/}
                    {/*    {AppStatic.appStaticHookJourneyText.ro.translation}*/}
                    {/*</p>*/}
                    <p className="text-mono-1000 italic text-base">
                        {AppStatic.appStaticHookComingSoon.ro.translation}
                    </p>
                </div>
            </div>
        </div>
    );
}

export default AppHook;
